import React, { Fragment, useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, Nav } from "reactstrap";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import Breadcrumb from "../../../../layout/breadcrumb";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import withReducer from "../../../../store/withReducer";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import userReducer from "../../store";
import {
  closeEditExDialog,
  deleteExternalStaff,
  getExternalStaff,
  openEditExDialog,
  openNewInDialog,
  storeExternalStaff,
  updateExternalStaff,
} from "../../store/staffSlice";
import ExternalStaffForm from "./externalStaffForm";

const defaultValues = {
  id: "",
  name: "",
  email: "",
  phone: "",
  rep_no: "",
};
const dataMenu = [
  {
    type: 0,
    text: "User",
    link: "/user",
  },
  {
    type: 1,
    text: "External Staff",
    link: "",
  },
];

const schema = yup.object().shape({
  name: yup.string().required("This is required field"),
  email: yup.string().required("You must enter an Email"),
});

const ExternalStaff = () => {
  const [staffData, setStaffData] = useState([]);
  const [isCreated, setIsCreated] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const repNoErrorRef = useRef(null);
  const dispatch = useDispatch();

  const resolver = async (values, context, options) => {
    const yupResult = await yupResolver(schema)(values, context, options);
    if (repNoErrorRef.current) {
      yupResult.errors.rep_no = repNoErrorRef.current;
    }
    return yupResult;
  };

  const {
    handleSubmit,
    formState,
    reset,
    control,
    register,
    setValue,
    trigger,
    getValues,
    setError,
    clearErrors,
    watch,
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver,
  });
  const { errors } = formState;

  const repNoValue = watch("rep_no");
  useEffect(() => {
    const currentId = getValues("id");
    const duplicate = repNoValue && staffData.some(
      (s) => s.rep_no === repNoValue && String(s.id) !== String(currentId)
    );
    if (duplicate) {
      repNoErrorRef.current = { type: "manual", message: "Rep. No already exists" };
      setError("rep_no", repNoErrorRef.current);
    } else {
      repNoErrorRef.current = null;
      clearErrors("rep_no");
    }
  }, [repNoValue, staffData]);
  const closeDialog = () => {
    dispatch(closeEditExDialog());
  };

  const onSubmitForm = (dialog, data) => {
    if (repNoErrorRef.current) return;

    setButtonDisable(true);
    const formData = {
      id: data.id,
      name: data.name,
      email: data.email,
      phone: data.phone,
      rep_no: data.rep_no,
    };
    if (dialog.type === "new") {
      dispatch(storeExternalStaff({ ...formData })).then((res) => {
        setButtonDisable(false);
        if (!res.error) {
          setIsCreated(true);
          closeDialog(dialog.type);
        }
      });
    } else {
      dispatch(updateExternalStaff({ ...formData })).then((res) => {
        setButtonDisable(false);
        if (!res.error) {
          closeDialog(dialog.type);
          setIsCreated(true);
        }
      });
    }
  };

  const onEdit = (row) => {
    reset({
      id: row.id,
      name: row.name,
      email: row.email,
      phone: row.phone || "",
      rep_no: row.rep_no || "",
    });
    dispatch(openEditExDialog(row));
  };

  const onDelete = (row) => {
    dispatch(deleteExternalStaff(row.id));
    setIsCreated(true);
  };

  useEffect(() => {
    dispatch(getExternalStaff()).then((res) => {
      setStaffData(res.payload);
      setIsCreated(false);
    });
  }, [dispatch, isCreated]);

  const tableColumns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      center: false,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      left: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
      left: true,
    },
    {
      name: "Rep. No",
      selector: (row) => row.rep_no,
      sortable: true,
      left: true,
    },
  ];

  return (
    <Fragment>
      <Container fluid className="">
        <Breadcrumb data={dataMenu} title="External Sales Person" />
        <div>
          <div>
            <Row>
              <Col sm="12">
                <Card>
                  <Row>
                    <Col sm="6">
                      <Nav tabs className="border-tab"></Nav>
                    </Col>
                    <Col sm="6">
                      <div className="float-sm-right p-3">
                        <a
                          className="btn btn-sm btn-primary"
                          onClick={() => {
                            dispatch(openNewInDialog());
                          }}
                        >
                          {" "}
                          <i className="fa fa-plus"></i> Add New Staff
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>

            <CommonDataTable
              headerColumns={tableColumns}
              gridData={staffData}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </div>

          <ModalFormSubmit
            defaultValues={defaultValues}
            schema={schema}
            buttonDisable={buttonDisable}
            formState={formState}
            handleSubmit={handleSubmit}
            onSubmitForm={onSubmitForm}
            noAction
            reset={reset}
            title="External Sales Person"
            selector="staff"
            dialog={({ staff }) => staff.staff.addDialog}
            closeDialog={closeDialog}
            setValue={setValue}
            getValues={getValues}
            btnText="Save"
          >
            <ExternalStaffForm
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
              trigger={trigger}
              getValues={getValues}
              staffData={staffData}
            />
          </ModalFormSubmit>
        </div>
      </Container>
    </Fragment>
  );
};

export default withReducer([{ staff: userReducer }])(ExternalStaff);
